import { BoltIcon } from "@octopusdeploy/design-system-icons";
import { themeTokens } from "@octopusdeploy/design-system-tokens";
export function LiveStatusConnectionIcon() {
    return <BoltIcon size={16} color={themeTokens.color.icon.secondary}/>;
}
